export default {
  IS_MOBILE(state) {
    return state.isMobile;
  },
  IS_DESKTOP(state) {
    return state.isDesktop;
  },
  PRODUCTS(state) {
    return state.products;
  },
  CART(state) {
    return state.cart;
  },
};
